import { render } from "./LinesComponent.vue?vue&type=template&id=85c85fde&scoped=true"
import script from "./LinesComponent.vue?vue&type=script&lang=js"
export * from "./LinesComponent.vue?vue&type=script&lang=js"

import "./LinesComponent.vue?vue&type=style&index=0&id=85c85fde&scoped=true&lang=css"

import exportComponent from "/Users/dmitriy-pc/Projects/ds-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85c85fde"]])

export default __exports__